import StudentDisciplinesPage from "./StudentDisciplinesPage";

export default StudentDisciplinesPage;